import { Oraculo } from "@core/oraculo";
import style from "@styles/pages/oraculo/base-node.module.scss";
import React from "react";

export const Clause = ({ clause, onClick }) => {
  const edit = (event) => {
    if (onClick) {
      return onClick(event, {
        action: "edit",
        target: clause.id,
      });
    }
  };

  return (
    <div className={style.condition}>
      <OperandChip type={clause.type} operand={clause.operand} data={clause} />
      <div className={style.edit} onClick={edit}>
        <i className="fal fa-gear" />
      </div>
    </div>
  );
};

const OperandChip = ({ type, operand, data }) => {
  const { label, value, range } = data;
  const text = Oraculo.operandLabel(type, operand, { value, range });
  const _value = Oraculo.formatValue(type, operand, { label, value, range });

  return (
    <div className={style.name}>
      <span>{text}&nbsp;&nbsp;-&nbsp;&nbsp;</span>
      <strong>{_value}</strong>
    </div>
  );
};
